import { includes } from 'lodash';
import * as moment from 'moment';

const truthfulStrings = ['t', 'y'];

export const deserializers = {
    deserializeDate(value: string): moment.Moment {
        return value ? moment(value) : null;
    },
    deserializeUtc(value: string): moment.Moment {
        return value ? moment.parseZone(value) : null;
    },
    deserializeBooleanFlag(value: string): boolean {
        const valueLowerCase = (value || '').toLowerCase();
        return includes(truthfulStrings, valueLowerCase);
    }
};